import React from 'react';
import { useTranslation } from 'react-i18next';
import './EventTypeSelection.css';
import selectedIcon from '../../assets/icons/ui/selected.svg';

interface EventTypeSelectionProps {
  value: 'inPerson' | 'online';
  onChange: (value: 'inPerson' | 'online') => void;
}

const EventTypeSelection: React.FC<EventTypeSelectionProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="event-type-selection">
      <button
        className={`event-type-button ${value === 'online' ? 'selected' : ''}`}
        onClick={() => onChange('online')}
      >
        {value === 'online' && <img src={selectedIcon} alt="Selected" className="selected-icon" />}
        {t('online')}
      </button>

      <button
        className={`event-type-button ${value === 'inPerson' ? 'selected' : ''}`}
        onClick={() => onChange('inPerson')}
      >
        {value === 'inPerson' && <img src={selectedIcon} alt="Selected" className="selected-icon" />}
        {t('in_person')}
      </button>
    </div>
  );
};

export default EventTypeSelection;
